import React, { ReactNode } from "react";
import { Button, Modal } from "react-bootstrap";

export type AlertDialogProps = {
    show: boolean
    message: ReactNode
    okClickFunc: () => void,
};


const AlertDialog = (props: AlertDialogProps) => {

    const handleClose = () => {
        props.okClickFunc();
    }

    return (
        <Modal show={props.show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>注意</Modal.Title>
            </Modal.Header>
            <Modal.Body>{props.message}</Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>
                    OK
                </Button>
            </Modal.Footer>
      </Modal>
    );
}

export default AlertDialog;